import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

// Campos que solo usan CostoKgSec (sin KgSecos)
const CostoOnlyColumns = {
    enero: { CostoKgSec: 0 },
    febrero: { CostoKgSec: 0 },
    marzo: { CostoKgSec: 0 },
    abril: { CostoKgSec: 0 },
    mayo: { CostoKgSec: 0 },
    junio: { CostoKgSec: 0 },
    julio: { CostoKgSec: 0 },
    agosto: { CostoKgSec: 0 },
    septiembre: { CostoKgSec: 0 },
    octubre: { CostoKgSec: 0 },
    noviembre: { CostoKgSec: 0 },
    diciembre: { CostoKgSec: 0 },
};

export const DatosEditablesSolidos =
{
    // EntradasMPAProduccion: { rowName: 'Entradas MP a producción', ...DefaultMonthsColumns },
    GtosDeCompraDeMP: { rowName: '(+) Gtos de compra de MP', ...CostoOnlyColumns },
    GtosFabricacionDelMes: { rowName: '(+) Gtos. Fabricación del mes', ...CostoOnlyColumns },
    ProdTermMesAnterior: { rowName: '(+) Prod. Term. Mes anterior', ...DefaultMonthsColumns },
    CostoVtaDelMes: { rowName: '(-) Costo Vta. Del Mes', ...DefaultMonthsColumns },
    ProdTerminFinal: { rowName: '(=) Prod. Termin. Final', ...DefaultMonthsColumns },
}

export const TotalesSolidos =
{
    // ProduccionDelMes: { rowName: '(=) Producción del mes', ...DefaultMonthsColumns },
    // ProdTermDisponible: { rowName: '(=) Prod. Term. Disponible', ...DefaultMonthsColumns },
}

export const SolidosData = {
    ...DatosEditablesSolidos,
    ...TotalesSolidos
}
